export default "__VITE_ASSET__2rcfnc$4__";